import useTranslation from 'next-translate/useTranslation';
import NextLink from 'next/link';

import { Link } from '@/atoms';
import { Card } from '@/molecules';

import Calendar from '@/assets/icons/Calendar.svg';

import type { FunctionComponent } from 'react';
import type { TypeCardBlogProps } from './types';

/**
 * CardBlog
 */
export const CardBlog: FunctionComponent<TypeCardBlogProps> = ({
  date,
  image,
  slug,
  title,
  description,
  ...props
}: TypeCardBlogProps) => {
  const { t, lang } = useTranslation('common');

  return (
    <Card
      multimediaProps={{ image, heigth: 200 }}
      backgroundColor="surface-00"
      {...props}
      classNames={{
        content: 'flex flex-col gap-5 text-text-primary',
      }}
    >
      <h3 className="text-subtitle text-subtitle--large">{title}</h3>

      {description && (
        <div
          className="font-thin"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {(date || slug) && (
        <div className="mt-auto flex flex-wrap justify-between gap-4">
          {date && (
            <div className="flex flex-row items-center gap-1">
              <Calendar width={20} height={20} />
              <span className="font-thin">
                {new Intl.DateTimeFormat(lang).format(new Date(date))}
              </span>
            </div>
          )}

          {slug && (
            <NextLink href={slug} passHref prefetch={false}>
              <Link arrow={false} underline variant="primary">
                {t('components.organisms.blog.readMore')}
              </Link>
            </NextLink>
          )}
        </div>
      )}
    </Card>
  );
};

CardBlog.displayName = 'CardBlog';
